<template>
  <v-container>
    <v-form ref="form">
      <v-subheader class="text-h3">{{ $t('trainingOfAskodForm.formCaption') }}</v-subheader>

      <v-text-field
        :label="$t('trainingOfAskodForm.personName')"
        v-model="formData.name"
        :rules="[rules.required]"
        required>
      </v-text-field>

      <v-text-field
        :label="$t('trainingOfAskodForm.phoneNumber')"
        v-model="formData.phoneNumber"
        :rules="[rules.required, rules.phone]"
        required>
      </v-text-field>

      <v-text-field
        :label="$t('trainingOfAskodForm.EmailAddress')"
        v-model="formData.email"
        :rules="[rules.required, rules.email]"
        required>
      </v-text-field>

      <v-text-field
        :label="$t('trainingOfAskodForm.InstitutionName')"
        v-model="formData.institutionName"
        :rules="[rules.required]"
        required>
      </v-text-field>

      <v-checkbox
        :label="$t('trainingOfAskodForm.askodUserCourse')"
        v-model="formData.isUser">
      </v-checkbox>
      <v-checkbox
        :label="$t('trainingOfAskodForm.askodAdminCourse')"
        v-model="formData.isAdmin">
      </v-checkbox>
      <v-checkbox
        :label="$t('trainingOfAskodForm.askodConsultantCourse')"
        v-model="formData.isConsultant">
      </v-checkbox>

      <v-textarea
        :label="$t('trainingOfAskodForm.notice')"
        v-model="formData.comment">
      </v-textarea>
      <app-captcha
        ref="recaptcha"
        :isBudgeHidden="false"
        @verify="submitForm($event)"
      />
      <v-btn @click="submit">{{ $t('trainingOfAskodForm.submitForm') }}</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import serviceDataAccess from '@/services/service.data-access'
import AppCaptcha from '@/components/_shared/AppCaptcha.vue'

export default {
  name: 'ConsultationForm',
  components: { AppCaptcha },
  data: () => ({
    formData: {
      name: '',
      phoneNumber: '',
      email: '',
      institutionName: '',
      comment: '',
      isUser: false,
      isAdmin: false,
      isConsultant: false
    }
  }),
  computed: {
    rules() {
      return {
        required: v => !!v || this.$t('trainingOfAskodForm.requiredField'),
        phone: v => /^(\+\d{1,3}[- ]?)?\d{10}$/.test(v) || this.$t('trainingOfAskodForm.phoneRule'),
        email: v => /.+@.+\..+/.test(v) || this.$t('trainingOfAskodForm.emailRule')
      }
    }
  },
  methods: {
    submit() {
      this.$refs.recaptcha.execute()
    },
    async submitForm(token) {
      if (this.$refs.form.validate()) {
        try {
          this.formData.googleReCaptchaResponse = token
          await serviceDataAccess.sendConsultationForm(this.formData)
          this.$uiService.success('Форма відправлена успішно')
          this.clearFields()
        } catch (e) {
          this.$uiService.error('Помилка відправки форми', e)
        }
      }
    },
    clearFields() {
      this.formData = {
        name: '',
        phoneNumber: '',
        email: '',
        institutionName: '',
        comment: '',
        isUser: false,
        isAdmin: false,
        isConsultant: false
      }
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
